var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4659 89.4036V102.472H15.8943C13.7912 102.476 13.7177 105.714 15.8943 105.739H104.105C106.228 105.69 106.277 102.525 104.105 102.472H66.533V89.4036C66.533 88.1989 65.8714 87.1576 64.8995 86.5899V74.702H77.9677C79.7687 74.702 81.2347 73.236 81.2347 71.435V24.0633C81.2347 22.2623 79.7687 20.7963 77.9677 20.7963H64.8995V17.5293C64.8995 15.7282 63.4335 14.2622 61.6325 14.2622H58.3654C56.5644 14.2622 55.0984 15.7282 55.0984 17.5293V20.7963H42.0302C40.2292 20.7963 38.7631 22.2623 38.7631 24.0633V71.435C38.7631 73.236 40.2292 74.702 42.0302 74.702H55.0984V86.5899C54.1264 87.1575 53.4659 88.1989 53.4659 89.4036ZM63.267 102.472H56.7329V89.4036H63.267V102.472ZM58.3665 86.1366V74.7014H61.6335V86.1366H58.3665ZM58.3665 17.5286H61.6335V20.7957H58.3665V17.5286ZM42.0312 71.4344V24.0627H77.9687V71.4344H42.0312Z",
    fill: "#1585CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0682 27.3296H46.9318C46.0293 27.3296 45.2983 28.0606 45.2983 28.9631V58.3666C45.3391 60.5106 48.5245 60.5187 48.5653 58.3666V30.5972H71.4347V64.9006H46.9313C44.7954 64.9252 44.7791 68.1351 46.9313 68.1677H73.0677C73.9702 68.1677 74.7012 67.4367 74.7012 66.5342V28.9626C74.7012 28.0601 73.9707 27.3296 73.0682 27.3296Z",
    fill: "#1585CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white",
    transform: "translate(14 14)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_sign.c720a156f87416c50f86d6a7cdac013d.svg";